var React = require('react');

function ArrowBlank (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M31,60A30.008,30.008,0,0,1,19.322,2.358,30.008,30.008,0,0,1,42.677,57.643,29.813,29.813,0,0,1,31,60ZM26.328,19.362a.824.824,0,0,0-.587.243.839.839,0,0,0-.243.587.825.825,0,0,0,.244.587L35.1,30.135l-9.359,9.358a.83.83,0,0,0,1.174,1.174l9.943-9.944a.828.828,0,0,0,0-1.174L26.915,19.6A.836.836,0,0,0,26.328,19.362Z","transform":"translate(61 60) rotate(180)","fill":"currentColor"}));
}

ArrowBlank.defaultProps = {"viewBox":"0 0 60 60"};

module.exports = ArrowBlank;

ArrowBlank.default = ArrowBlank;
